import React from 'react'
import { COLORS } from 'static/constants'
import styled from 'styled-components'
import IconButton from './IconButton'
import InputText from './InputText'

interface ICounter {
  defaultValue?: number
  minValue?: number
  isLimit?: boolean
  changeableCountLabel?: boolean
  handleChange?: (count: number) => void
  disabled?: boolean
}

const Counter: React.VFC<ICounter> = ({
  defaultValue,
  minValue = 0,
  isLimit = false,
  changeableCountLabel = false,
  handleChange,
  disabled = false,
}) => {
  const [count, setCount] = React.useState<number | null>(defaultValue || minValue)

  const minus = () => {
    if (disabled) {
      return
    }
    if (count === null) {
      setCount(minValue)
      return
    }
    if (count > minValue) {
      setCount(old => old - 1)
    }
  }

  const add = () => {
    if (disabled) {
      return
    }
    if (count === null) {
      setCount(minValue)
    }
    if (!isLimit) {
      setCount(old => old + 1)
    }
  }

  const updateCount = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      setCount(null)
      return
    }
    const value = parseInt(e.target.value, 10)
    if (value < minValue) {
      setCount(minValue)
    } else {
      setCount(value)
    }
  }

  const onBlurUpdateCount = (e: React.FocusEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      setCount(minValue)
      return
    }
    updateCount(e)
  }

  React.useEffect(() => {
    if (handleChange) {
      handleChange(count)
    }
  }, [count])

  return (
    <CounterWrapper>
      <IconButton
        size="sm"
        iconName="remove"
        disabled={disabled || count <= minValue}
        handleClick={minus}
      />
      {changeableCountLabel ? (
        <span className="changeableCount">
          <InputText
            type="number"
            value={count}
            onChangeHandler={updateCount}
            onBlurHandler={onBlurUpdateCount}
            name="counter_input"
            forCounter={true}
          />
        </span>
      ) : (
        <span className="number">{count}</span>
      )}

      <IconButton size="sm" handleClick={add} iconName="add" disabled={disabled || isLimit} />
    </CounterWrapper>
  )
}

const CounterWrapper = styled.div`
  display: flex;
  align-items: center;
  .changeableCount {
    width: 32px;
    height: 32px;
    text-align: center;
    margin: 0 16px;
  }

  .number {
    display: block;
    font-size: 14px;
    font-weight: 700;
    width: 20px;
    text-align: center;
    margin: 0 16px;
  }
`

export default Counter
